<mwe-form [formModel]="countryFormModel()" (formChanged)="onChanges()" />

@if (useManualAddressForm()) {
  <mwe-manual-address-input [initialData]="manualAddress()" (formChanged)="receiveSelectionFinished($event)" />
} @else {
  <mwe-address-search-wrapper
    [ignoreAvailableZipCodes]="true"
    [selectedOlav]="initialOlavEntry()"
    (addressInputCompleted)="receiveSelectionFinished($event)"
    (noResultsFound)="changeToManualAddressForm()"
  />
}
